<template>
  <div class="ant-upload-preview">
    <div style="width: 100%">
      <el-upload
        class="avatar-uploader"
        :show-file-list="false"
        action
        :before-upload="beforeUpload"
        :http-request="handleChange"
      >
        <img
          v-if="imageUrl"
          :style="{ width: width + 'px', height: height + 'px' }"
          :src="imageUrl"
          class="avatar"
        />
        <span v-else>
          <i
            v-if="loading"
            :style="{
              width: width + 'px',
              height: height + 'px',
              lineHeight: height + 'px',
            }"
            class="el-icon-loading avatar-uploader-icon"
          ></i>
          <span
            v-else
            :style="{
              width: width + 'px',
              height: height + 'px',
              lineHeight: height + 'px',
            }"
            class="empty-box"
          >
            <img class="update_img" src="@/assets/icon_update_img.png" />
          </span>
        </span>
      </el-upload>
    </div>
  </div>
</template>
<script>
export default {
  name: "ImageCropper",
  props: {
    // 上传图片的大小，单位M
    imgSize: {
      type: Number,
      default: 2,
    },
    // 图片地址
    imageUrl: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 108,
    },
    height: {
      type: Number,
      default: 108,
    },
  },
  data() {
    return {
      loading: false,
      isStopRun: false,
    };
  },

  methods: {
    //从本地选择文件
    handleChange(info) {
      if (this.isStopRun) {
        return;
      }
      this.loading = true;
      this.getBase64(info.file, (imageUrl) => {
        this.loading = false;
        this.$emit("crop-upload-success", {
          base64: imageUrl,
          file: info.file,
        });
      });
    },
    // 上传之前 格式与大小校验
    beforeUpload(file) {
      this.isStopRun = false;
      var fileType = file.type;
      if (fileType.indexOf("image") < 0) {
        this.$message.warning("请上传图片");
        this.isStopRun = true;
        return false;
      }
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJpgOrPng) {
        this.$message.error("你上传图片格式不正确!");
        this.isStopRun = true;
      }
      const isLtSize = file.size < this.imgSize * 1024 * 1024;
      if (!isLtSize) {
        this.$message.error("图片大小不能超过" + this.imgSize + "MB!");
        this.isStopRun = true;
      }
      return isJpgOrPng && isLtSize;
    },

    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-upload-preview {
  .empty-box {
    display: block;
    border-radius: 4px;
    border: 1px solid #cccccc;
    .update_img {
      margin-top: 20px;
      width: 20px;
      height: 20px;
    }
  }
}
::v-deep .avatar-uploader .el-upload--text {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 20px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
::v-deep .avatar-uploader-icon {
  font-size: 22px;
  color: #ccc;
  width: 108px;
  height: 108px;
  line-height: 108px;
  text-align: center;
}
::v-deep.avatar {
  width: 108px;
  height: 108px;
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/ImageCropper/index.vue